import { render, staticRenderFns } from "./InvestorDetails.vue?vue&type=template&id=0c38cac9&scoped=true&"
import script from "./InvestorDetails.vue?vue&type=script&lang=js&"
export * from "./InvestorDetails.vue?vue&type=script&lang=js&"
import style0 from "./InvestorDetails.vue?vue&type=style&index=0&id=0c38cac9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38cac9",
  null
  
)

export default component.exports